export default __webpack_public_path__ + "static/1358-a2842d3f807b5a49a6aa9832fb347c4c.gif";